<template>
    <div class="report-item-wrapper">
        <div class="report-item-header-wrapper">
            <div class="create-time-wrapper">
                {{ item ? item.createdTime : '无创建日期' }}
            </div>
            <div class="order-no-wrapper">
                订单号: <a>{{ item.acceptanceNo }}</a>
            </div>
        </div>
        <div class="report-item-content-wrapper">
            <div style="width:25%" class="report-item-info-field">
                {{  item && item.samplename ? item.samplename : 'x0' }}
            </div>
            <div style="width:25%" class="report-item-info-field">
                {{ item && item.samplecount ? 'x' +  item.samplecount : 'x0' }}
            </div>
            <div style="width:25%" class="report-item-info-field">
                {{ item.entrustSumFee? '金额：' + item.entrustSumFee: '暂无计费'}}
            </div>
            <div :style="{width:'25%',color: reportStatus.color}" class="report-item-info-field">
                {{ reportStatus.name }}
            </div>
        </div>
        <div class="report-no-wrapper">
            报告编号：{{ item.reportNo }}
        </div>
        <div v-if="(item.status === 'sended' || item.status === 'archiveed')" class="express-no-wrapper">
            快递单号：{{ item.no }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportItem',
    props:{
        item:{
            type: Object,
            default: () => {
                return {
                    createdTime: '2020-08-01',
                    acceptanceNo: '12345',
                    samplename: '样品名称',
                    samplecount: 12,
                    fee: '金额',
                    reportStatus: 'draft',
                    reportNo: '121212',
                    no: '快递单号'
                }
            }
        }
    },
    computed: {
       reportStatus(){
            if(this.item && this.item.status){
                for (let i = 0; i < this.reportStatusList.length; i++) {
                    let element = this.reportStatusList[i];
                    if(element.code === this.item.status){
                        return element
                    }
                }
            }
            return '暂无信息'
        }
    },
    data(){
        return {
            reportStatusList: [
                {code: 'draft', name: '新建', color: '#ad8b00'},
                {code: 'reviewing', name: '待审核	', color: '#ad8b00'},
                {code: 'approving', name: '待批准	', color: '#ad8b00'},
                {code: 'printing', name: '待打印', color: '#ad8b00'},
                {code: 'stamping', name: '待盖章', color: '#ad8b00'},
                {code: 'stamped', name: '已盖章', color: '#ad8b00'},
                {code: 'sending', name: '待发放	', color: '#ad8b00'},
                {code: 'sended', name: '已发放', color: '#ad8b00'},
                {code: 'archiveed', name: '已归档	', color: '#ad8b00'}
            ]
        }
    },
}
</script>

<style lang="scss">
.report-item-wrapper{
    display: flex;
    flex-direction: column;
    margin: 16px 16px 0;
    padding: 16px;
    box-sizing: border-box;
    background-color: #ffffff;

    .report-item-header-wrapper{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .order-no-wrapper{
            a {color: #2d8cf0;}
        }
    }

    .report-item-content-wrapper{
        display: flex;
        flex-direction: row;
        height: 48px;

        .report-item-info-field{
            height: 48px;
            line-height: 48px;
            text-align: center;
        }
    }
}
</style>